import Animate from '../../../lib/animate';
export default Animate;
